import React from 'react';
import {withStyles} from '@material-ui/core/styles';
import IconButton from "@material-ui/core/IconButton";
import Icon from "@material-ui/core/Icon";
import CardActions from "@material-ui/core/CardActions/CardActions";
import CardContent from "@material-ui/core/CardContent/CardContent";
import Card from "@material-ui/core/Card/Card";
import CardHeader from "@material-ui/core/CardHeader/CardHeader";
import Grid from "@material-ui/core/Grid/Grid";
import Typography from "@material-ui/core/Typography/Typography";
import Divider from "@material-ui/core/Divider/Divider";
import swal from 'sweetalert';

import Layout from '../../components/Layout';
import CsrfField from "../../components/Form/CsrfField";
import i18n from "../../i18n";
import {Paper} from "@material-ui/core";

const deleteNotification = (e, notification) => {
    e.preventDefault();
    swal({
        title: i18n.get('notification.remove'),
        dangerMode: true,
        icon: "warning",
        buttons: [
            i18n.get('default.cancel'),
            i18n.get('default.delete'),
        ],
    }).then((confirmed) => {
        if (confirmed) {
            document.getElementById(`delete-${notification.id}`).submit();

        }
    });
};

const cardHeader = (notification, classes) => (
    <CardHeader title={notification['data']['title']}
                subheader={notification['data']['subtitle']}
                className={classes.oneLiner}
                titleTypographyProps={{
                    className: classes.oneLiner,
                }}
                subheaderTypographyProps={{
                    className: classes.oneLiner,
                }}
    >
    </CardHeader>
);

const cardActions = (notification, classes) => (
    <CardActions>
        <Grid container justify="space-between" alignItems="center">
            <Grid item>
                <Typography variant="subtitle2">{notification.created_at}</Typography>
            </Grid>
            <Grid item>
                <IconButton onClick={(e) => deleteNotification(e, notification)} className={classes.actionButton}>
                    <Icon className={classes.actionButtonIcon}>delete</Icon>
                </IconButton>
            </Grid>
        </Grid>
    </CardActions>
);

const loadCard = (classes, notification) => {
    return (
        <Card className={classes.card}>
            <a
                href={`/notifications/${notification.id}`}
                className={notification.read_at}
            >
                {cardHeader(notification, classes)}
                <CardContent>
                    CONTENT
                </CardContent>
            </a>
            <Divider/>
            {cardActions(notification, classes)}
        </Card>
    );
};

const NotifcationIndex = ({classes, notifications}) => {
    return (
        <Layout>
            {notifications.map(notification =>
                <React.Fragment key={notification.id}>
                    {loadCard(classes, notification)}
                    <form
                        id={`delete-${notification.id}`}
                        action={`/notifications/${notification.id}`}
                        className={classes.deleteForm}
                        method="POST"
                    >
                        <input type="hidden" name="_method" value="delete"/>
                        <CsrfField/>
                    </form>
                </React.Fragment>
            )}
            {notifications.length === 0 && (
                <Paper className={classes.paper}>
                    <Typography
                        variant={"h2"}
                    >
                        Keine Benachrichtigungen / Aufgaben verfügbar
                    </Typography>
                </Paper>
            )}
        </Layout>
    );
};

const styles = theme => ({
    oneLiner: {
        ...theme.helpers.oneLiner,
    },
    paper: {
        marginTop: theme.spacing.unit * 3,
        marginBottom: theme.spacing.unit * 3,
        padding: theme.spacing.unit * 2,
        [theme.breakpoints.up(600 + theme.spacing.unit * 3 * 2)]: {
            marginTop: theme.spacing.unit * 6,
            marginBottom: theme.spacing.unit * 6,
            padding: theme.spacing.unit * 3,
        },
    },
    deleteForm: {
        display: 'none',
    },
    card: {
        float: "left",
        margin: theme.spacing.unit * 1.5,
        width: 300,
        "& a": {
            textDecoration: "none",
        }
    },
    actionButton: {
        padding: 4,
    },
    actionButtonIcon: {
        fontSize: 20,
    },
});

export default withStyles(styles)(NotifcationIndex);



// WEBPACK FOOTER //
// ./resources/assets/js/pages/notification/Index.jsx